import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { RootState } from "../../app/store";
import { TBS_API_URL, TBS_TENANT_ID } from "../../config";
import type { CloseShiftInput, OpenShiftInput, Shift } from "../../types/tbs/shifts";

// Tiendas Biai — till shifts.

export const tbsShiftsApi = createApi({
  reducerPath: "tbsShiftsApi",
  tagTypes: ["TbsShift"],
  baseQuery: fetchBaseQuery({
    baseUrl: TBS_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      if (TBS_TENANT_ID) headers.set("X-Tenant-Id", TBS_TENANT_ID);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    /**
     * **A 404 here is a state, not a failure.** No open shift is what makes the POS show the
     * "abrir turno" screen, and the contract chose that over a 200 with an empty body. So callers
     * branch on `error.status === 404` rather than treating it as something to report.
     */
    getCurrentShift: builder.query<Shift, { terminal?: string } | void>({
      query: (params) =>
        `/v1/shifts/current${params?.terminal ? `?terminal=${encodeURIComponent(params.terminal)}` : ""}`,
      providesTags: [{ type: "TbsShift", id: "CURRENT" }],
    }),

    openShift: builder.mutation<Shift, OpenShiftInput>({
      query: (body) => ({ url: "/v1/shifts/open", method: "POST", body }),
      invalidatesTags: [{ type: "TbsShift", id: "CURRENT" }],
    }),

    closeShift: builder.mutation<Shift, { id: string; body: CloseShiftInput }>({
      query: ({ id, body }) => ({ url: `/v1/shifts/${id}/close`, method: "POST", body }),
      invalidatesTags: [{ type: "TbsShift", id: "CURRENT" }],
    }),
  }),
});

export const { useGetCurrentShiftQuery, useOpenShiftMutation, useCloseShiftMutation } =
  tbsShiftsApi;
